import React from "react";
import { TeamHeroWrap } from "./TeamHero.styled";

const TeamHero = () => {
  return (
    <TeamHeroWrap>
      <div>
        <h2>Our Team</h2>
      </div>
    </TeamHeroWrap>
  );
};

export default TeamHero;
